import {
  CONFIRMED_GET_SERVICE_CALLER_PRESCRIPTIONS_ACTION,
  CONFIRMED_GET_SERVICE_CALLER_PATIENT_DETAILS,
  CONFIRMED_MARK_PRESCRIPTION_AS_COMPLETE,
  CONFIRMED_PRESCRIPTION_REASSIGN,
  FAILED_PRESCRIPTION_REASSIGN,
  CONFIRMED_GET_REPEAT_PRESCRIPTIONS,
  FAILED_GET_REPEAT_PRESCRIPTIONS,
} from "./ServiceCallerPrescriptionType";

import {
  getPatientDetails,
  getServiceCallerPrescription,
  getServiceCallerprescriptionMarkAsComplete,
  reassignPrescriptionService,
  regeneratePrescription
  // getRepeatPrescriptionList
} from "../../services/ServiceCallerPrescriptionService";

function getAuthToken(getState) {
  const stateToken = getState().auth?.authKey;
  if (stateToken) return stateToken;

  const storedUser = localStorage.getItem("userDetails");
  return storedUser ? JSON.parse(storedUser).token : null;
}

export function getServiceCallerPrescriptionsAction(prescriptionData) {
  return async (dispatch, getState) => {
    try {
      const response = await getServiceCallerPrescription({
        patient_id: prescriptionData.patient_id,
      });

      console.log("API raw response for patient prescriptions:", response);

      const apiData = response?.data;

      if (apiData?.status === "success" && Array.isArray(apiData.data)) {
        const mappedData = apiData.data.map((prescription) => {
          const medicinesWithDelivery = prescription.medicines.map(
            (medicine) => {
              // Set default delivery status and option if not provided
              const delivery_option = medicine.delivery_option || "pending";
              const delivery_status = medicine.delivery_status || "pending";

              return {
                prescription_medicine_id: medicine.prescription_medicine_id,
                medicine_name: medicine.medicine_name,
                dose: medicine.dose,
                frequency: medicine.frequency,
                qty: medicine.qty,
                delivered_qty: medicine.delivered_qty || 0,
                delivery_status: delivery_status,
                delivery_option: delivery_option,
                how_to_take: medicine.how_to_take,
                is_custom: medicine.is_custom || "No",
              
                custom_duration_in_days: medicine.custom_duration_in_days || 0,
                updated_qty: medicine.updated_qty || 0,
              };
            }
          );

          return {
            prescription_id: prescription.prescription_id,
            patient_id: prescription.patient_id,
            duration: prescription.duration,
            is_stop: prescription.is_stop || "No",
            original_duration: prescription.original_duration,  
            note: prescription.note || "No notes",
            prescribed_by: prescription.PrescribedBy || "Unknown",
            created_by: prescription.created_by,
            created_at: prescription.created_at,
            is_regular_service_call: prescription.is_regular_service_call || "No",
            is_regular_followup: prescription.is_regular_followup || "No",
            medicines: medicinesWithDelivery,
            prescription_explained: prescription.prescription_explained,
            prescription_explained_date:
              prescription.prescription_explained_date || null,
            medicine_started: prescription.medicine_started,
            medicine_started_date: prescription.medicine_started_date || null,
            diseases: prescription.diseases || [],
            receipt_download_link: prescription.receipt_download_link || null,
            discount_amount: prescription.discount_amount || 0,
            discount_type: prescription.discount_type || "",

            prescription_payment_status: prescription.prescription_payment_status || "PENDING",

            totals: {
              items_subtotal: prescription.items_subtotal || 0,
              items_cgst_amount: prescription.items_cgst_amount || 0,
              items_sgst_amount: prescription.items_sgst_amount || 0,
              items_igst_amount: prescription.items_igst_amount || 0,
              gst_price: prescription.gst_price || 0,
              igst_price: prescription.igst_price || 0,
            },
          };
        });

        dispatch({
          type: CONFIRMED_GET_SERVICE_CALLER_PRESCRIPTIONS_ACTION,
          payload: mappedData,
        });

        console.log("Final mapped prescriptions:", mappedData);
        return mappedData;
      }

      return [];
    } catch (error) {
      console.error(
        "Failed to fetch patient prescriptions:",
        error.response?.data || error.message
      );
      return [];
    }
  };
}

export function markServiceCallerPrescriptionAsCompleteAction(
  prescriptionData
) {
  return async (dispatch) => {
    try {
      const response = await getServiceCallerprescriptionMarkAsComplete({
        prescription_id: prescriptionData.prescription_id,
        mark_as_complete: "yes",
      });
      console.log("Raw response from markAsComplete:", response);
      const apiData = response?.data;
      if (apiData?.status === "success") {
        const updatedPrescription = {
          prescription_id: prescriptionData.prescription_id,
          mark_as_complete: true,
          message: apiData.message || "Marked as complete",
        };
        dispatch({
          type: CONFIRMED_MARK_PRESCRIPTION_AS_COMPLETE,
          payload: updatedPrescription,
        });
        return updatedPrescription;
      }
      return {};
    } catch (error) {
      console.error(
        "Failed to mark prescription as complete:",
        error.response?.data || error.message
      );
      return {};
    }
  };
}

export function getPatientDetailsAction(patient_id) {
  return async (dispatch, getState) => {
    try {
      const token = getAuthToken(getState);

      const response = await getPatientDetails(patient_id, token);
      console.log("API Response:", response);

      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_GET_SERVICE_CALLER_PATIENT_DETAILS,
          payload: response.data.data,
        });
      } else {
        showErrorAlert(
          response?.data?.message || "Failed to get patient details"
        );
      }
    } catch (error) {
      console.error("API Error:", error);
      showErrorAlert(error.message || "Failed to get patient details");
    }
  };
}

export function reassignPrescriptionAction(payload) {
  return async (dispatch) => {
    try {
      const response = await reassignPrescriptionService(payload);

      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_PRESCRIPTION_REASSIGN,
          payload: payload,
        });

        return { success: true };
      } else {
        throw new Error(
          response?.data?.message || "Failed to reassign prescription"
        );
      }
    } catch (error) {
      console.error("Reassign error:", error);
      return { success: false };
    }
  };
}

// export function getRepeatPrescriptionListAction(doctor_id) {
//   return async (dispatch) => {
//     try {
//       const response = await getRepeatPrescriptionList(doctor_id);

//       if (response?.data?.status === "success") {
//         dispatch({
//           type: CONFIRMED_GET_REPEAT_PRESCRIPTIONS,
//           payload: response.data.data,
//         });

//         return response.data.data;
//       } else {
//         throw new Error(
//           response?.data?.message || "Failed to fetch repeat prescriptions"
//         );
//       }
//     } catch (error) {
//       dispatch({
//         type: FAILED_GET_REPEAT_PRESCRIPTIONS,
//         payload: error.message,
//       });

//       return [];
//     }
//   };
// }

export function regeneratePrescriptionAction(prescription_id) {
  return async (dispatch) => {
    try {
      const response = await regeneratePrescription(prescription_id);

      if (response?.data?.status === "success") {
        return { success: true, data: response.data };
      }

      return { success: false };
    } catch (error) {
      console.error(
        "Regenerate prescription failed:",
        error.response?.data || error.message
      );
      return { success: false };
    }
  };
}